export default __webpack_public_path__ + "static/media/imgimg-4838.56585f4f.jpeg";